export const mapApiOptions = [
  {
    id: 1,
    name: 'snapToRoad',
    displayName: 'SETTINGS.SNAP_TO_ROAD',
  },
  {
    id: 2,
    name: 'geolocationForRoutes',
    displayName: 'SETTINGS.GEOLOCATION_ROUTE_STOP',
  },
  {
    id: 3,
    name: 'geolocationForFuelStation',
    displayName: 'SETTINGS.GEOLOCATION_FUEL_STATION',
  },
]
